<script>
  const isLogin=false;
  const userInfo={};
  export default{
    isLogin,
    userInfo,
  }
</script>



// WEBPACK FOOTER //
// src/components/Global/Global.vue